export const PlanDividerDot = () => {
  return <i className="fa-solid fa-circle plan-divider-dot mx-2" />;
};
